<template>
  <div class="qr-container">
    <div class="info-box">
      <div class="page-header">
        <div class="page-title" @click="$router.push('/user-center')">
          <button class="back-btn" />
          <span>我的二维码</span>
        </div>
      </div>
      <!--二维码-->
      <div class="qr-box">
        <div class="qr-code">
          <img v-if="qr_code" class="qr-image" :src="qr_code" />
          <div class="load-error" v-else>
            二维码走丢了，点击<a @click="refresh">刷新</a>重新加载
          </div>
        </div>
        <button class="btn primary btn-style" @click="refresh">点击刷新二维码</button>
        <button class="btn btn-style" @click="goBack">返回个人信息</button>
      </div>
    </div>
  </div>
</template>

<script>
import { get_qrcode } from '@/api/user'
// 禁止缩放
import UnScaleMixin from '@/mixins/un_scale_mixin'

export default {
  mixins: [UnScaleMixin],
  data() {
    return {
      qr_code: null
    }
  },
  created() {
    this.load_qr()
  },
  methods: {
    async load_qr() {
      const qr_resp = await get_qrcode()
      this.qr_code = qr_resp.qrcode
    },
    refresh(e) {
      e.preventDefault();
      this.load_qr()
    },
    goBack(e) {
      e.preventDefault();
      this.$router.push("/user-center")
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/qrcode.scss';
</style>